/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/layout/get-field-zone-layout";
import { EmailFieldDisplay } from "./display";
import { EmailFieldEdit } from "./edit";

const EmailField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <EmailFieldDisplay />,
        editComponent: <EmailFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
EmailField.displayName = "EmailField";
export { EmailField };
